import WarehouseIndex from "./WarehouseIndex.vue";
import WarehouseAdd from "./WarehouseAdd.vue";
import WarehouseDetail from "./WarehouseDetail.vue";
import WarehouseEdit from "./WarehouseEdit.vue";
import WarehouseUpload from "./WarehouseUpload.vue";

let routes= [
    {
        path: '',
        meta: {
          title: "List Warehouse",
        },
        name: "WarehouseIndex",
        component: WarehouseIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Warehouse",
        },
        name: "WarehouseAdd",
        component: WarehouseAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Warehouse",
        },
        name: "WarehouseDetail",
        component: WarehouseDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Warehouse",
        },
        name: "WarehouseEdit",
        component: WarehouseEdit
    },
    {
        path: 'upload',
        meta: {
          title: "Upload Warehouse",
        },
        name: "WarehouseUpload",
        component: WarehouseUpload
    },
    
]

export default routes
  